// Enum representing the shipment event chronological order type
export enum ChronologicalTypes {
    Current = 'Current',
    Future = 'Future',
    Historic = 'Historic',
  }
